import { fromShortToLong } from '@/components/shared/languageCodes';
import store from '../../index';

function getSubDomainLanguage() {
  const full = window.location.host;
  const parts = full.split('.');
  const sub = parts[0];
  if (sub && (sub.length == 2 || sub.length == 3)) {
    return fromShortToLong[sub];
  }
  return undefined;
}

function getUserLanguage(state) {
  if (state.userSelectedLanguage) {
    return state.userSelectedLanguage;
  }

  if (getSubDomainLanguage()) {
    return getSubDomainLanguage();
  }

  return undefined;
}

const userSelectedLanguage = state => getUserLanguage(state);

const getLessonLanguage = (state, getters) => {
  const selectedLearnedLanguage = getters.getSelectedLearnedLanguage;
  const lessonLanguage = store.getters['contents/lesson'].learnedLanguageId;

  return lessonLanguage || selectedLearnedLanguage || 'en';
};

const getUserOverwriteBrowserLanguagePersisted = state =>
  state.userOverwriteBrowserLanguagePersisted;

const getSubDomain = () => getSubDomainLanguage();

const getSiteLanguage = (state) => {
  const userOverWriteLanguage = store.state.userOverwriteBrowserLanguage;
  const userOverWriteLanguagePersisted =
    state.userOverwriteBrowserLanguagePersisted;
  const isUserLoggedIn = store.getters.hasToken;
  const userLang = getUserLanguage(state);
  if (
    (userLang && isUserLoggedIn) ||
    userOverWriteLanguage ||
    userOverWriteLanguagePersisted
  ) {
    return userLang;
  }

  if (getSubDomainLanguage()) {
    return getSubDomainLanguage();
  }

  const lang = navigator.language;
  if (lang) {
    const shortLang = lang.substring(0, 2);
    const foundLang = fromShortToLong[shortLang];
    return foundLang || 'en_US';
  }
  return 'en_US';
};

const getSelectedLearnedLanguage = (state) => {
  const languageCode = state.selectedLearnedLanguage;
  if (languageCode) {
    const availableLanguages = ['en', 'de', 'es', 'fr', 'enpam', 'hu', 'esp01bus', 'esp02med', 'esp03leg', 'esp04aca', 'esp05tou', 'esp06it', 'esp07tec', 'esp08cat', 'esp09eng', 'esp10vet'];
    if (availableLanguages.includes(languageCode)) {
      return languageCode;
    }
  }

  return 'en';
};

const userSelectedLevel = state => state.userSelectedLevel;

const userSelectedGoal = state => state.userSelectedGoal;

const lesson = state => state.lesson;

const island = state => state.island;

const islandMusic = state => state.island.musicEnabled;

const lessonMusic = state => state.lesson.soundEnabled;

const needSlowSound = state => state.lesson.needSlowSound;

const needMotivation = state => state.lesson.needMotivation;

const getAdaptiveTestStatus = state =>
  state.userSettings.optional_adaptive_testing_enabled;

const isNotificationsEnabled = state => state.isNotificationsEnabled;

const getUserSettings = state => id => state.userSettings[id];

const getTeachBotSpeed = state => state.teachBotSpeed;

const startFromClass = state => state.startFromClass;

const isPageNotFound = state => state.isPageNotFound;

const needLastLearnedCard = state => state.needLastLearnedCard;

const getProPopupType = state => state.proPopupType;

const getIsNexusUser = state => state.isNexusUser;

const getLastRoute = state => state.lastRoute;

const getDktOptions = (state) => {
  const defaultState = {
    classId: undefined,
    assignmentId: undefined,
    dktAssignmentId: undefined,
    lessonId: undefined,
    needToSaveOptions: false,
    fromDkt: false,
  };

  let dktOptions = window.sessionStorage.getItem('dktOptions');
  let returnObject = defaultState;
  if (dktOptions) {
    dktOptions = JSON.parse(dktOptions);
    returnObject = { ...defaultState, ...dktOptions };
  }
  const classId = state.dktOptions.classId;
  const fromDkt = state.dktOptions.fromDkt;
  const dktAssignmentId = state.dktOptions.dktAssignmentId;
  if (fromDkt !== undefined && classId !== undefined) {
    returnObject.classId = classId;
    returnObject.fromDkt = fromDkt;
    returnObject.dktAssignmentId = dktAssignmentId;
  }
  return returnObject;
};

const getMobileSupportModalStatus = state => state.mobileSupportModalStatus;

const getInvalidationStatus = state => state.invalidationIsRunning;

const getWindowWidthMobile = state => state.windowWidthMobile;

const getWindowWidth = state => state.windowWidth;

const getNarratorLanguage = state => state.narratorLanguage;

const getWCAGSettings = state => state.wcag;

const getIsKHUser = state => state.isKHUser;

export default {
  getSelectedLearnedLanguage,
  userSelectedLanguage,
  getUserOverwriteBrowserLanguagePersisted,
  getSiteLanguage,
  getSubDomain,
  userSelectedLevel,
  userSelectedGoal,
  lesson,
  island,
  isNotificationsEnabled,
  getUserSettings,
  islandMusic,
  lessonMusic,
  getTeachBotSpeed,
  needSlowSound,
  needMotivation,
  getAdaptiveTestStatus,
  startFromClass,
  isPageNotFound,
  needLastLearnedCard,
  getProPopupType,
  getIsNexusUser,
  getLastRoute,
  getDktOptions,
  getInvalidationStatus,
  getWindowWidthMobile,
  getWindowWidth,
  getNarratorLanguage,
  getWCAGSettings,
  getLessonLanguage,
  getMobileSupportModalStatus,
  getIsKHUser,
};
